import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import {EmailFormCell} from "@treeosk/common"
import queries from "../../../queries";
import SpecificCellPreview from "./SpecificCellPreview";

class EmailFormCellPreview extends React.Component {

  render() {
    const { cell, screenType } = this.props;
    const defaultRender = () => <FontAwesomeIcon icon={['far', 'address-card']} />;

    return (
      <SpecificCellPreview
        cell={cell}
        defaultRender={defaultRender}
        query={queries.cells.email_form.get}
        additionalVariables={{screen_type_id: screenType.id}}
      >
        {(formCell) => (
          <EmailFormCell
            preview={true}
            cell={{...formCell, width: formCell.coordinates.width}}
            uriTransformer={(uri) => uri}

          />
        )}
      </SpecificCellPreview>
    );
  }

}

export default EmailFormCellPreview;
